import axiosApi from "../axiosInstance";

const getCategoryList = async () => {
  try {
    const response = await axiosApi.get(`/Category/getAllCategory`);
    return response?.data;
  } catch (error) {
    console.log("Error getCategoryList===>:", error);
    return error?.response?.data;
  }
};

const addCategory = async (body) => {
  try {
    const response = await axiosApi.post(`/Category/CreateCategory`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addCategory ===>", error);
    return error?.response?.data;
  }
};

const getCategorydrop = async (departmentId = 0) => {
  try {
    const response = await axiosApi.get(`/Category/GetCategoryList/${departmentId || 0}`);
    return response?.data;
  } catch (error) {
    console.log("Error getCategorydrop===>:", error);
    return error?.response?.data;
  }
};

export const categoryService = {
  getCategoryList,
  addCategory,
  getCategorydrop,
};
